<template>
  <div>
    <!-- <header class="lmy-header lmy-header-w" >
      <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
      龙猫度假
    </header> -->
    <div class="lmy-new-search" style="padding: .3rem;position: fixed;z-index: 999;background: #fff;">
      <i class="iconfont icon-yuyin" onclick="window.history.go(-1)" style="line-height: .7rem;background-color: #f8f8f8; border-radius: 5px;"></i>
      <div v-if="cityData.PackageCityName" class="city-box" @click="cityData.show=true">
        {{cityData.PackageCityName}}
      </div>
      <div v-else class="city-box" @click="cityData.show=true">
        推荐
      </div>
      <div class="search-box">
        <div class="input-box">
          <input type="text" v-model="Name" placeholder="请输入搜索关键字">
        </div>
        <span class="search-btn" @click="changeFilter"><i class="iconfont icon-search"></i></span>
      </div>
    </div>
    <div class="lmy-flash" style="padding: 0 .3rem; padding-top: 1.4rem;">
        <div class="flash-content" v-for="item in list" @click="toDetail(item)">
          <div class="flash-figure">
            <div class="bannerTag">
              <p class="red" v-if="item.Type==1">优惠度假</p>
              <p class="orange" v-else>超值预售</p>
            </div>
            <img class="product-img" v-if="item.ListImg" :src="item.ListImg | replaceImgSrc(4)" @error='imgEro(item)' alt="">
            <img class="product-img" v-else src="../../assets/img/hotelDetailsDf.png" alt="">
            <div class="icon" v-show="item.CityName">
              <i class="iconfont icon-lmy-dingwei" ></i>
              {{item.CityName}}
            </div>
          </div>
          <div class="price">
            <div class="text">
              ￥<span class="number">{{item.Price||' XX '}}</span> 起
            </div>
            <div>
              <div class="time" v-if="(dateIntervene(item.SaleStart)<=0)&&item.clockHour&&(item.clockHour<48)">
                <span class="on" v-if="item.clockEnd">距结束 :</span>
                <span class="under" v-html="item.clockEnd"></span>
              </div>
              <div class="time" v-if="dateIntervene(item.SaleStart)>0">
                <span class="on" v-if="item.clockStart">距开售 :</span>
                <span class="under" v-html="item.clockStart"></span>
              </div>
            </div>
          </div>
          <div class="flash-sum">
            <div class="info">
              <p>{{item.ProductName}}</p>
              <div class="box" v-if="item.Tags&&item.Tags.length>0"><div class="PackageTag">{{item.Tags[0]}}</div></div>
              <!-- <div class="tag">{{item.Tags[0]}}</div> -->
              <!-- <span class="flash-sum-tags">{{item.SubType}}</span> -->
            </div>
          </div>

        </div>
    </div>
    <infinite-loading @infinite="initData" ref="infiniteLoading" style="margin-bottom: 1rem;">
		    <span slot="no-more" @click="cityData.show=true">
		     您还可以<span style="color:#2391ff">更换城市</span>，查看更多产品
		    </span>
		    <!-- <div slot="no-more" class="line-package" >
            <hr>
            <span>我们是有底线的</span>
        </div> -->
        <span slot="no-results" >
		     暂时没有相关产品...
		    </span>
    </infinite-loading>
    <transition  name="slide" >
      <City @select="cityData.select" @cancel='cityData.cancel' :cityData="cityData"  v-show="cityData.show" ></City>
    </transition>
  </div>
</template>
<script >
import City from "./cmpnt/city.vue"; //城市选择器
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "free-list",
  components: {
    InfiniteLoading,
    City:City
  },

  data() {
    return {
      list: [],
      Page: 1,
      PageSize: 10,
      total: 0,
      Name: "",
      cityData: {
        show: false,
        from: 1,
        PackageID: this.$route.query.CityID || "2003",
        PackageCityName: this.$route.query.CityName || "深圳",
        select: (city, from) => {
          this.cityData.show = false;
          this.cityData.PackageID = city.ID || "2003";
          this.cityData.PackageCityName = city.Name || "深圳";
          this.changeFilter();
        },
        cancel:()=>{
          this.cityData.show=false;
        }
      }
    };
  },
  
  mounted() {
    this.Name = this.$route.query.Name || "";
    this.changeFilter();
  },
  methods: {
    // 图片错误处理
    imgEro(img) {
      var that = this;
      that.list.forEach(item => {
        if (item.ProductId == img.ProductId) {
          item.ListImg = "";
        }
      });
    },
    changeFilter($state) {
      this.Page = 1;
      this.total = 0;
      this.list = [];
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
      });
    },
    toDetail(item) {
      this.$router.push(
        "/packageDetails?ProductId=" +
          item.ProductId 
      );
    },
    initClock(list) {
      for (var i = 0; i < list.length; i++) {
        this.timeLoop(list[i], list[i].SaleStart, list[i].SaleEnd);
      }
    },
    timeLoop(item, start, end) {
      var num = 1;
      var that = this;
      var end = that.dateIntervene(end);
      var start = that.dateIntervene(start);
      var time = setInterval(function() {
        num++;
        if (num >= end) {
          clearInterval(time);
        } else {
          var hour = that.betDateH(end - num)
          that.$nextTick(function() {
            if(start>0){
              that.$set(item, "clockStart", that.betDateFomate(start - num));
            }else if(start<=0&&hour<48){
              that.$set(item, "clockHour", hour);
              that.$set(item, "clockEnd", that.betDateFomate(end - num));
            }
          });
        }
      }, 1000);
    },
    betDateH(time){
      return Math.floor((time / 60 / 60));
    },
    dateIntervene(date) {
      var s1 = new Date().getTime();
      var s2 = new Date(date).getTime();
      return parseInt((s2 - s1 > 0 ? s2 - s1 : 0) / 1000);
    },
    betDateFomate(time) {
      var d, h, m, s;
      if (time >= 0) {
        d = Math.floor(time / 60 / 60 / 24);
        h = Math.floor((time / 60 / 60) % 24);
        m = Math.floor((time / 60) % 60);
        s = Math.floor(time % 60);
      }

      var intv =
        "<span>" +
        d +
        "</span> 天 <span>" +
        (h < 10 ? "0" + h : h) +
        "</span> : <span>" +
        (m < 10 ? "0" + m : m) +
        "</span> : <span>" +
        (s < 10 ? "0" + s : s)

      return intv;
    },

    initData($state) {
      if (this.total > 0 && (this.Page - 1) * this.PageSize > this.total) {
        $state.complete();
        return;
      }
      var that = this;
      var params = {
        CustomerNO:'BJ100138',
        Page: that.Page,
        PageSize: that.PageSize,
        Name: that.Name,
        CityID: that.cityData.PackageID,
        Type: 0,
        IsFromPC:false
      };
      that
        .postRequest({
          url: that.Api.getOnlinePackageList,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess && res.Result.length > 0) {
            that.total = res.Total;
            that.Page++;
            that.list = that.list.concat(res.Result);
            that.initClock(res.Result);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/free/list.vue